<script>
    import { BetonBlock, BlockPack, BrickBlock } from "./types/block";
    import MapX1 from "./components/x1/MapX1.svelte";

    const s = 40;
    let blocks = new BlockPack ( 0, 0, 26 * s, 26 * s );
    export const name = "Project X32";

    function createLevel ( data ) {
        for (let i in data) {
            for (let j in data[i]) {
                let v = data[i][j];

                if (v !== 0) {
                    if (v === 1) {
                        blocks.els.push ( new BrickBlock ( j * s, i * s ) );
                    } else if (v === 2) {
                        blocks.els.push ( new BetonBlock ( j * s, i * s ) );
                    }
                }
            }
        }

        let fastFind = { 0 : {}, 1 : {}, 2 : {}, 3 : {} };
        let ls = 8 * s;

        for (let x = 0; x < 4; x++) {
            for (let y = 0; y < 4; y++) {
                let blockPack = new BlockPack ( x * ls, y * ls, ls, ls );
                blocks.sub.push ( blockPack );
                fastFind[x][y] = blockPack;
            }
        }

        for (let block2 of blocks.els) {
            let block = block2;

            fastFind[Math.floor ( block.x / ls )][Math.floor ( block.y / ls )]
            .els.push ( block );
        }

        for (let i = 0; i < blocks.sub.length;) {
            let sub = blocks.sub[i];
            if (sub.els.length === 0) {
                blocks.sub.splice ( i, 1 );
            } else {
                i++;
            }
        }

        ls = 2 * s;

        for (let pack2 of blocks.sub) {
            let pack = pack2;

            for (let x = 0; x < 4; x++) {
                for (let y = 0; y < 4; y++) {
                    let blockPack = new BlockPack ( pack.x + x * ls, pack.y + y * ls, ls, ls );
                    pack.sub.push ( blockPack );
                    fastFind[x][y] = blockPack;
                }
            }

            for (let block2 of pack.els) {
                let block = block2;

                fastFind[Math.floor ( (block.x - pack.x) / ls )][Math.floor ( (block.y - pack.y) / ls )]
                .els.push ( block );
            }

            for (let i = 0; i < pack.sub.length;) {
                let sub = pack.sub[i];
                if (sub.els.length === 0) {
                    pack.sub.splice ( i, 1 );
                } else {
                    i++;
                }
            }
        }
    }

    createLevel ( [
        [2, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0],
        [0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0],
        [0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0],
        [0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0],
        [0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 2, 2, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0],
        [0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 2, 2, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0],

        [0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0],
        [0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0],
        [0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 0],
        [2, 2, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 2, 2],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],

        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 1, 1, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0],
        [0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0],
        [0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0],
        [0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0],
        [0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0],
        [0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0],
        [0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0],

        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    ] );

    window.blocks = blocks;

    let w = 1040, h = 1040, x = 0, y = 0;
</script>

<main>
    <MapX1
            bind:width={w}
            bind:height={h}
            bind:els={blocks.els}
            bind:sub={blocks.sub}
            bind:x={x}
            bind:y={y}
    />
</main>
